export const DATE = 'Date';
